import { BuildConfig } from './build.config.types';

export type Environment = {
  production: boolean;
  configPath: string;
  multiBasket?: boolean;
} & Partial<BuildConfig>;
